import { useCallback } from 'react';

export function useFileInput(onFile: (base64: string, filename?: string) => void) {
  return useCallback(
    (input: React.ChangeEvent<HTMLInputElement> | File) => {
      const file = input instanceof File ? input : input.target.files?.[0];

      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (reader.result && typeof reader.result === 'string') {
            onFile(reader.result, file.name);
          }
        };
        reader.readAsDataURL(file);
      }
    },
    [onFile],
  );
}
